// Reports and blocks (T-801, PRIVACY §4–5, SCREENS S16).
import { z } from 'zod';

export const REPORT_TARGET_TYPES = ['event', 'user', 'message'] as const;
export const REPORT_REASONS = [
	'spam',
	'fake',
	'scam',
	'harassment',
	'unsafe',
	'illegal',
	'inappropriate',
	'other',
] as const;
export const REPORT_DETAILS_MAX = 500;
/** PRIVACY §4: reports are rate limited per user. */
export const REPORTS_PER_HOUR = 10;

export const createReportRequestSchema = z.strictObject({
	targetType: z.enum(REPORT_TARGET_TYPES),
	targetId: z.uuid(),
	reason: z.enum(REPORT_REASONS),
	details: z
		.string()
		.trim()
		.max(REPORT_DETAILS_MAX)
		.nullish()
		.transform((value) => (value === undefined || value === null || value === '' ? null : value)),
});

/** 201 for a new report; 200 with the same id when this reporter already reported the target. */
export const reportResponseSchema = z.object({ id: z.uuid() });

export const blockParamsSchema = z.object({ userId: z.uuid() });
export const blockResponseSchema = z.object({ blocked: z.boolean() });

export const blockedUsersResponseSchema = z.object({
	items: z.array(
		z.object({
			user: z.object({
				id: z.uuid(),
				/** Null: the account was deleted (T-804). */
				displayName: z.string().nullable(),
				photoUrl: z.url().nullable(),
			}),
			blockedAt: z.iso.datetime(),
		}),
	),
});

export type ReportTargetType = (typeof REPORT_TARGET_TYPES)[number];
export type ReportReason = (typeof REPORT_REASONS)[number];
export type CreateReportRequest = z.input<typeof createReportRequestSchema>;
export type BlockedUsersResponse = z.infer<typeof blockedUsersResponseSchema>;
